export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterColumn {
  heading: string;
  links: FooterLink[];
}

export const LEGAL_LINKS: FooterLink[] = [
  { label: "Terms of service", href: "/terms-of-service" },
  { label: "Privacy policy", href: "/privacy-policy" },
];

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: "About Cledar",
    links: [
      { label: "More info", href: "#" },
      { label: "Contact & adress line", href: "#" },
    ],
  },
  {
    heading: "Expertise",
    links: [
      { label: "More info", href: "#" },
      { label: "Contact & adress line", href: "#" },
    ],
  },
  {
    heading: "Adress",
    links: [
      { label: "More info", href: "#" },
      { label: "Contact & adress line", href: "#" },
    ],
  },
];
